<template>
  <b-modal
    @show="isBusy = false"
    @ok="handleOk"
    cancelTitle="Abbrechen"
    okTitle="OK"
    @cancel="handleCancel"
    id="ImportVEModal"
    title="Vergabeeinheiten aus Excel Datei importieren"
    size="lg"
  >
    <span v-if="rows.length == 0 && !isBusy" class="float-right">
      <a href="/Vorlage_VE_Import.xlsx">
        <b-icon icon="download" />
        Vorlage herunterladen
      </a>
    </span>
    <b-form-group
      id="input-group-file"
      label="Datei für Import auswählen"
      label-for="input-file"
      class=""
      v-if="rows.length == 0 && !isBusy"
    >
      <b-form-file
        v-model="fileToImport"
        accept=".xlsx"
        placeholder="Datei wählen..."
        drop-placeholder="Drop file here..."
        @change="onFileSelected"
        autofocus
        class="mb-2"
      ></b-form-file>
      <b-alert class="mt-2" variant="danger" dismissible @dismissed="showNoRowsAlert = false" :show="showNoRowsAlert">
        Die angegebene Datei enthielt keine gültigen Daten.
      </b-alert>
      <hr class="mb-4" />
      <b-icon variant="secondary" icon="question-circle-fill" class="mr-2" />

      <strong>Informationen zum Import aus einer Excel Tabelle</strong>
      <br />

      <p class="pl-4 mt-1">
        <small>
          <li>
            &nbsp;Eingelesen werden 2 Spalten einer einfachen Exceltabelle.
            <br />
          </li>

          <li>
            &nbsp;Nach der Überschrift in Zeile 1 werden die Daten ab Zeile 2 aus den ersten 2 Spalten ausgelesen.
            <br />
          </li>

          <li>
            &nbsp;In den Spalten B (Bezeichnung) sind auch leere Einträge erlaubt.
            <br />
          </li>

          <li>
            &nbsp;Der Import endet in der Zeile mit einem leeren Eintrag in Spalte A.
          </li>
        </small>
      </p>

      <img src="@/assets/xlsvetemplate.png" class="mb-1 mt-2 ml-4" />
    </b-form-group>
    <div class="text-center">
      <b-spinner variant="primary" label="Spinning" v-show="isBusy" :key="isBusy"></b-spinner>
    </div>
    <div v-if="rows.length > 0 && !isBusy">
      <div class="row">
        <div class="col col-8">
          <b-form-group label="Bestehende Vergabeeinheiten " v-slot="{ ariaDescribedby }">
            <b-form-radio
              v-model="overwriteOption"
              :aria-describedby="ariaDescribedby"
              name="overwriteOption"
              class="mb-2"
              :value="true"
            >
              Aktualisieren
              <div class="text-muted small">
                Die Bezeichnung vorhandener VE werden bei identischer VE-Nr. durch den Import überschrieben.
              </div>
            </b-form-radio>
            <b-form-radio
              v-model="overwriteOption"
              :aria-describedby="ariaDescribedby"
              name="overwriteOption"
              :value="false"
            >
              Beibehalten
              <div class="text-muted small">
                Die Bezeichnungvorhandener VE bleiben bei identischer VE-Nr. erhalten, die Informationen der zu
                importierenden Datei werden ignoriert.
              </div>
            </b-form-radio>
          </b-form-group>
        </div>
        <div class="col col-4">
          <label>Präfix</label>
          <b-input
            placeholder="Präfx"
            size="sm"
            type="text"
            class="mb-2"
            v-model="prefix"
            debounce="300"
            @change="updatePrefix"
          />
          <div class="text-muted small">
            Ein Präfix wird vor eine jede VE hinzugefügt.
          </div>
        </div>
      </div>
      <hr class="mt-0" />
      <b-form ref="importForm" id="importForm">
        <b-table :items="rows" :fields="fields" sticky-header="474px" bordered small head-variant="light">
          <template #head(checked)="">
            <b-form-checkbox v-model="checkedAll" @change="onCheckAllChange"></b-form-checkbox>
          </template>
          <template #cell(checked)="data">
            <b-form-checkbox @change="onCheckItemChange(data.item)" v-model="data.item.checked"></b-form-checkbox>
          </template>
          <template #cell(Ordinal)="data">
            <input class="form-control border-0" type="text" v-model.lazy="data.item.Ordinal" />
          </template>
          <template #cell(DisplayName)="data">
            <input class="form-control border-0" type="text" v-model.lazy="data.item.DisplayName" />
          </template>
          <template #cell(actions)="data">
            <b-icon icon="trash" variant="grey" class="action-button" @click="deleteItem(data.item)"></b-icon>
          </template>
        </b-table>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import ProjectStore from '@/store/Projects';
import allocationUnitsService from '@/service/AllocationUnitsService';
import settingsStore from '@/store/Settings';

var XLSX = require('xlsx');

export default {
  emits: ['success', 'error'],
  data() {
    return {
      fileToImport: [],
      rows: [],
      fields: [
        {
          key: 'checked',
          label: '',
          tdClass: 'text-center align-middle',
          thClass: 'text-center',
          thStyle: 'width: 40px;'
        },
        { key: 'Ordinal', label: 'VE', thStyle: 'width: 100px;' },
        { key: 'DisplayName', label: 'Bezeichnung' },
        { key: 'actions', label: '', tdClass: 'text-center align-middle', thStyle: 'width: 60px' }
      ],
      checkedAll: false,
      isBusy: false,
      overwriteOption: true,

      settingsStore,
      prefix: '',
      showNoRowsAlert: false
    };
  },
  methods: {
    handleOk(evt) {
      if (!this.$refs.importForm.checkValidity()) {
        evt.preventDefault();
        return this.$refs.importForm.reportValidity();
      }
      evt.preventDefault();
      this.isBusy = true;
      allocationUnitsService
        .createBulk(
          ProjectStore.activeProject.DbId,
          this.rows.filter(x => x.checked), // only those where x.checked == true
          this.overwriteOption
        )
        .then(() => {
          this.$showSuccess(this, 'Excel Import', 'Vergabeeinheiten angelegt.');
          this.$emit('success', null);
        })
        .catch(err => {
          if (err.response) {
            this.$bvModal
              .msgBoxOk(err.response.data.error, {
                title: 'Import abgebrochen',
                okVariant: 'danger',
                headerTextVariant: 'danger',
                centered: true
              })

              .catch(err => {
                console.log(err);
              });
          } else {
            this.$showError(this, err.toString());
            this.$emit('error', err);
          }
        })
        .finally(() => {
          this.$bvModal.hide('ImportVEModal');
          setTimeout(() => {
            this.$nextTick(() => {
              this.handleCancel(); // clean up the form
              this.isBusy = false;
            });
          }, 300);
        });
    },
    handleCancel() {
      this.rows = [];
      this.fileToImport = [];
      this.prefix = '';
    },
    onCheckAllChange() {
      this.rows.map(x => {
        return (x.checked = this.checkedAll);
      });
    },
    onCheckItemChange(item) {
      if (!item.checked) this.checkedAll = false;
    },
    onFileSelected(event) {
      this.isBusy = true;

      const toFile = event.target.files ? event.target.files[0] : null;

      if (typeof toFile == 'undefined') return;

      this.fileToImport = toFile;

      const reader = new FileReader();

      reader.onload = e => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        var counter = 1;
        var idx = 0;
        this.rows = data.slice(1).map(x => {
          let displayName = x[1].substring(0, 100);

          if (typeof displayName == 'undefined') displayName = '(leere Bezeichnung) (' + counter++ + ')';

          return {
            Ordinal: x[0],
            OrdinalOriginal: x[0],
            DisplayName: displayName,
            checked: true,
            index: idx++
          };
        });
        if (this.rows.length == 0) this.showNoRowsAlert = true;
        this.checkedAll = true;
        this.isBusy = false;
      };
      setTimeout(() => {
        // need this hack, because isBusy would otherwise not reactivley be propageted to spinner component
        reader.readAsBinaryString(this.fileToImport);
      }, 300);
    },
    deleteItem(item) {
      const index = this.rows.findIndex(x => x.Ordinal == item.Ordinal);
      this.rows.splice(index, 1);
    },
    updatePrefix() {
      for (const item of this.rows) {
        item.Ordinal = this.prefix + item.OrdinalOriginal;
      }
    }
  },
  watch: {
    prefix() {
      this.updatePrefix();
    }
  }
};
</script>

<style></style>
